import type { AllRouteEndpoints } from "../routeTypes";

export const simulationCasesPath = "/:app_group_id/conversational/simulation/cases";
export const simulationCasePath = "/:app_group_id/conversational/simulation/cases/:id";
export const simulationRunsPath = "/:app_group_id/conversational/simulation/runs";
export const simulationRunPath = "/:app_group_id/conversational/simulation/runs/:id";
export const simulationWebhooksPath = "/:app_group_id/conversational/simulation/webhooks";

// Run detail embeds the run's cases as currently saved, so a case edit or delete refreshes it too.
export const simulationCaseCacheKeys: AllRouteEndpoints[] = [
  simulationCasePath,
  simulationCasesPath,
  simulationRunPath,
];
